var map = {
	"./minicipiosBahia": [
		"QxNn",
		5
	],
	"./minicipiosBahia.json": [
		"QxNn",
		5
	],
	"./municipiosAmapa": [
		"JNqm",
		4
	],
	"./municipiosAmapa.json": [
		"JNqm",
		4
	],
	"./municipiosDefault": [
		"UTSS",
		3
	],
	"./municipiosDefault.json": [
		"UTSS",
		3
	],
	"./municipiosMaranhao": [
		"vro7",
		2
	],
	"./municipiosMaranhao.json": [
		"vro7",
		2
	],
	"./municipiosPara": [
		"VZKQ",
		1
	],
	"./municipiosPara.json": [
		"VZKQ",
		1
	],
	"./municipiosRoraima": [
		"ZIwk",
		0
	],
	"./municipiosRoraima.json": [
		"ZIwk",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9IJZ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./static/seeds lazy ^\.\/.*$
// module id = 9IJZ
// module chunks = 12